import { gsap, ScrollTrigger, scrollSmootherInstance } from '../globals/gsap';
import Header from '../globals/header';
import { AppointmentOverlay, ApplicationOverlay } from '../globals/overlays';
import { over } from 'lodash';
import Intro from '../components/intro';

import Gallery from '../components/gallery';
import Hero from '../components/hero';
import Video from '../components/video';
import Door from '../components/door';
import CounterInput from '../components/counter-input';

import barba from '@barba/core';



class Default {

    heros = [];
    applicationOverlay = null;

    beforeLeave(data) {
        console.log('beforeLeave');
        if(data.next.namespace != 'detail') {
            Header.hideBacklink();
        }

        ScrollTrigger.getAll().forEach((instance) => {
            instance.kill();
        });
        Header.close();
    }

    afterLeave(data) {
        console.log('afterLeave');
        this.destroyHero();
    }

    beforeEnter(data) {
        if(data.next.namespace === 'detail' && barba.history.previous) {
            Header.showBacklink();
        }

        const scope = data.next.container;

        const modifier = $(scope).data('modifier') ?? null;

        let $html = $('html');

        if(modifier) {
            $html.addClass(modifier);
        } else {
            let hasShowConsent = $html.hasClass('show--consent');
            $html.removeClass();

            if(hasShowConsent) {
                $html.addClass('show--consent');
            }
        }

        // ScrollTrigger.refresh(true);
        scrollSmootherInstance.scrollTop(0);
        
        this.updateHeader(scope);
        this.initIntro(scope);
        this.initOverlayTriggers(scope);

        this.initHero(scope);
		this.initGallery(scope);
		this.initVideo(scope);
        this.initCounterInput(scope);
        this.initDoor(scope);
    }
    
    afterEnter(data) { 
        const scope = data.next.container;
        console.log('afterEnter');

        ScrollTrigger.refresh();
        // ScrollTrigger.update();
    }

    updateHeader = (scope) => {
        const newTitle = $(scope).data('title');
        const id = $(scope).data('id');
        const modifier = $(scope).data('modifier') ?? null;
        
        Header.setActiveLink(id);
        Header.updateBreadcrumb(newTitle);
        Header.collapseMobileNav();
    }

    initOverlayTriggers = (scope) => {
        const $overlayTriggers = $(scope).find('[data-overlay="trigger"]');

        $overlayTriggers.each((i, el) => {
            const target = $(el).data('target');

            $(el).on('click', () => {
                const target = $(el).data('target');
                if(target == 'terminanfrage') {
                    AppointmentOverlay.open();
                } else if (target == 'application') {
                    const preselectId = $(el).data('preselect-id');
                    console.log(preselectId);
                    ApplicationOverlay.open(preselectId);
                }
            });
        });
    }

	initIntro = (scope) => {
		const $intro = $(scope).find('[data-intro="el"]');
		console.log($intro);
		if($intro.length){
			new Intro($intro);
		}
	}


	initGallery = (scope) => {
		const $galleries = $(scope).find('[data-gallery="el"]');

		$galleries.each((i, el) => {
			new Gallery($(el));
		});
	}

  initHero = (scope) => {
    const $hero = $(scope).find('[data-hero="el"]');

    $hero.each((i, el) => {
      const hero = new Hero($(el));
			this.heros.push(hero);
    });
  }

	initVideo = (scope) => {
		const $video = $(scope).find('[data-video="el"]');

		$video.each((i, el) => {
			new Video($(el));
		});
	}

    destroyHero = (scope) => {
		this.heros.forEach(hero => {
			hero.destroy();
		});

		this.heros = [];
	}

    initDoor = (scope) => {
        const $door = $(scope).find('[data-door="el"]');

        $door.each((i, el) => {
            new Door($(el));
        });
    }

    initCounterInput = (scope) => {
        const $counterInput = $(scope).find('[data-counter-input="el"]');

        $counterInput.each((i, el) => {
            new CounterInput($(el));
        });
    }
}

export default Default;